import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Dictionary from '../entities/dictionary'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface DictionaryState extends ListState<Dictionary>{
    editDictionary:Dictionary;
}
class DictionaryModule extends ListModule<DictionaryState,any,Dictionary>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Dictionary>(),
        loading:false,
        editDictionary:new Dictionary()
    }
    actions={
        async getAll(context:ActionContext<DictionaryState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/SystemDictionary/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Dictionary>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<DictionaryState,any>,payload:any){
            await Ajax.post('/api/services/app/SystemDictionary/Create',payload.data);
        },
        async CreateKeywordAndCharacter(context:ActionContext<DictionaryState,any>,payload:any){
            await Ajax.post('/api/services/app/SystemDictionary/CreateKeywordAndCharacter',payload.data);
        },
        async update(context:ActionContext<DictionaryState,any>,payload:any){
            await Ajax.put('/api/services/app/SystemDictionary/Update',payload.data);
        },
        async delete(context:ActionContext<DictionaryState,any>,payload:any){
            await Ajax.delete('/api/services/app/SystemDictionary/CreateKeywordAndCharacter?Id='+payload.data.id);
        },
        async get(context:ActionContext<DictionaryState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/SystemDictionary/Get?Id='+payload.id);
            return reponse.data.result as Dictionary;
        },
        async getDictionType(context: ActionContext<DictionaryState, any>) {            
            let reponse = await Ajax.get('/api/services/app/SystemDictionary/GetDictionaryTypeList');
            return reponse.data.result
        },
        async settingUpdateCache(context:ActionContext<DictionaryState,any>){
            await Ajax.put('/api/services/app/Article/UpdateArticleCache');
        },
    };
    mutations={
        setCurrentPage(state:DictionaryState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:DictionaryState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:DictionaryState,dictionary:Dictionary){
            state.editDictionary=dictionary;
        }
    }
}
const dictionaryModule=new DictionaryModule();
export default dictionaryModule;